import './footer.html.twig';
import './footer.scss';
import './dac-certification-two-tick@2x.png';
import './dac-certification-two-tick@3x.png';
import './cyber-essentials-logo-1@2x.png';
import './cyber-essentials-logo-1@3x.png';
import './dc_badge.svg';


export default function () {
  const el = document.querySelector('.footer');
  if (!el) {
    return;
  }

  const accordions = el.querySelectorAll('.footer__title');

  const toggleAccordion = function () {
    this.classList.toggle('accordion--active');
    const panel = this.nextElementSibling;
    const accordionLinks = panel.querySelectorAll('a');
    if (this.classList.contains('accordion--active')) {
      this.setAttribute('aria-expanded', 'true');
      if (accordionLinks) {
        Array.prototype.forEach.call(accordionLinks, (accordionLink) => {
          accordionLink.setAttribute('tabindex', '0');
        });
      }
    } else {
      this.setAttribute('aria-expanded', 'false');
      if (accordionLinks) {
        Array.prototype.forEach.call(accordionLinks, (accordionLink) => {
          accordionLink.setAttribute('tabindex', '-1');
        });
      }
    }

    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = `${panel.scrollHeight}px`;
    }
  };

  const createAccordions = () => {
    Array.prototype.forEach.call(accordions, (accordion) => {
      accordion.removeAttribute('tabindex');
      accordion.setAttribute('aria-expanded', 'false');
      const links = el.querySelectorAll('a');
      if (links) {
        Array.prototype.forEach.call(links, (link) => {
          link.setAttribute('tabindex', '-1');
        });
      }
      accordion.addEventListener('click', toggleAccordion);
    });
  };

  const removeAccordions = () => {
    Array.prototype.forEach.call(accordions, (accordion) => {
      accordion.removeEventListener('click', toggleAccordion);
      accordion.setAttribute('tabindex', '-1');
      accordion.removeAttribute('aria-expanded');
      accordion.classList.remove('accordion--active');
      const links = el.querySelectorAll('a');
      if (links) {
        Array.prototype.forEach.call(links, (link) => {
          link.removeAttribute('tabindex');
        });
      }
    });
  };

  const resize = () => {
    // eslint-disable-next-line no-restricted-globals
    if (window.innerWidth < 1024) {
      createAccordions();
    } else {
      removeAccordions();
    }
  };

  window.addEventListener('resize', resize);

  resize();
}
